import { render, staticRenderFns } from "./modalsComment.vue?vue&type=template&id=45717daa&scoped=true"
import script from "./modalsComment.vue?vue&type=script&lang=js"
export * from "./modalsComment.vue?vue&type=script&lang=js"
import style0 from "./modalsComment.vue?vue&type=style&index=0&id=45717daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45717daa",
  null
  
)

export default component.exports